const WEBSOCKET_HOST = `wss://scalping-calculator-ws.fullstack-freelancer.ru`;
// const WEBSOCKET_HOST = `ws://127.0.0.1:3233`;
export default WEBSOCKET_HOST;
